import { singleSignOn, transportation } from '@/axios'

export default {
  login (payload) {
    return singleSignOn().post('sso-login', payload)
  },
  checkUser (paylod) {
    return singleSignOn().post('sso-check', paylod)
  },
  sendFirebaseToUser (payload) {
    return transportation().patch('users/fcm-token', { fcm_token: payload })
  }
}
